var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "initiate_discussion_wrap" }, [
    _c("div", { staticClass: "initiate_discussion_main" }, [
      _vm.region == "all" && _vm.editDetailsInfo == null
        ? _c(
            "div",
            { staticClass: "subordinate_module" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择讨论所属模块" },
                  on: { change: _vm.checkRegion },
                  model: {
                    value: _vm.regionValue,
                    callback: function($$v) {
                      _vm.regionValue = $$v
                    },
                    expression: "regionValue"
                  }
                },
                _vm._l(_vm.regionOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm.isSubordinateModule
                ? _c("p", { staticClass: "isSubordinateModule" }, [
                    _vm._v("请选择讨论所属模块")
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "theme_module" },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入内容",
              maxlength: "300",
              "show-word-limit": ""
            },
            on: { focus: _vm.isThemeFocus, blur: _vm.isThemeBlur },
            model: {
              value: _vm.themeValue,
              callback: function($$v) {
                _vm.themeValue = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "themeValue"
            }
          }),
          _vm._v(" "),
          _vm.isThemeValue
            ? _c("p", { staticClass: "is_theme_value" }, [
                _vm._v("请输入主题内容")
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content_module" },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("v-editor", {
            staticClass: "discuss_content",
            model: {
              value: _vm.discussContent,
              callback: function($$v) {
                _vm.discussContent = $$v
              },
              expression: "discussContent"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isChapterList
        ? _c(
            "div",
            { staticClass: "subordinate_teach" },
            [
              _vm._m(3),
              _vm._v(" "),
              _c("el-cascader", {
                attrs: {
                  "expand-trigger": "hover",
                  options: _vm.chapterOption,
                  props: _vm.chapterOptionProps,
                  clearable: "",
                  "change-on-select": "",
                  placeholder: "全部教学章节"
                },
                model: {
                  value: _vm.selectedChapter,
                  callback: function($$v) {
                    _vm.selectedChapter = $$v
                  },
                  expression: "selectedChapter"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.userType
        ? _c(
            "div",
            { staticClass: "Anonymous_publication" },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.isAnonymousValue,
                    callback: function($$v) {
                      _vm.isAnonymousValue = $$v
                    },
                    expression: "isAnonymousValue"
                  }
                },
                [_vm._v("匿名发表")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userType
        ? _c(
            "div",
            { staticClass: "is_top_ck" },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { disabled: _vm.isTopDisabled },
                  model: {
                    value: _vm.isTopValue,
                    callback: function($$v) {
                      _vm.isTopValue = $$v
                    },
                    expression: "isTopValue"
                  }
                },
                [_vm._v("置顶")]
              ),
              _vm._v(" "),
              _vm.isTopNum >= 3 && !_vm.isTopValue && _vm.isTopDisabled
                ? _c("p", [_vm._v("（最多置顶3条讨论主题哦！）")])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "publish" },
      [
        _c("el-button", { on: { click: _vm.publishDiscuss } }, [_vm._v("发表")])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tag_item_lable" }, [
      _c("i", [_vm._v("*")]),
      _c("span", [_vm._v("所属讨论区模块")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tag_item_lable" }, [
      _c("i", [_vm._v("*")]),
      _c("span", [_vm._v("主题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tag_item_lable" }, [
      _c("i"),
      _c("span", [_vm._v("内容")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tag_item_lable" }, [
      _c("i"),
      _c("span", [_vm._v("所属教学内容")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60a10cab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60a10cab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/discuss/component/initiateDiscussion.vue
// module id = null
// module chunks = 